import { useEffect, useState } from 'react';

export const useCheckVersion = (interval = 60000) => {
  const [isOutdated, setIsOutdated] = useState(false);

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const response = await fetch('/version.json', { cache: 'no-cache' });

        const data = await response.json();
        const currentVersion = localStorage.getItem('mobigestorVersion');

        if (currentVersion && currentVersion !== data.version) {
          setIsOutdated(true);
        }

        localStorage.setItem('mobigestorVersion', data.version);
      } catch (error) {
        console.error('Erro ao verificar a versão da aplicação', error);
      }
    };

    checkVersion();
    const intervalId = setInterval(checkVersion, interval);

    return () => clearInterval(intervalId);
  }, [interval]);

  return isOutdated;
};
